import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { TreeTable } from "primereact/treetable";
import { Suspense, useEffect, useState } from "react";
import { GetOrgSystemAlertList } from "./Services/AdvanceSettingService";
import ComponentLoader from "../../../Shared/Sidebar/ComponentLoader";
import { Button } from "primereact/button";

const OrgSystemAlert = () => {
  const [orgSystemAlertList, setOrgSystemAlertList] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const [treeTableData, setTreeTableData] = useState([]);
  const [editSystemAlertId, setEditSystemAlertId] = useState(null);
  const [alertDescription, setEditDescriptions] = useState({});

  useEffect(() => {
    getMasterOrgSystemAlerts();
  }, []);

  const handleInputChange = (event) => {
  };

  async function getMasterOrgSystemAlerts() {
    const params = { Name: "" };
    setIsloading(true);
    try {
      const data = await GetOrgSystemAlertList(params);
      const response = data?.Data || [];
      setOrgSystemAlertList(response);
      const grouped = response.reduce((acc, item) => {
        const { Category, SubCategory } = item;
        if (!acc[Category]) {
          acc[Category] = {};
        }
        if (!acc[Category][SubCategory]) {
          acc[Category][SubCategory] = [];
        }
        acc[Category][SubCategory].push(item);
        return acc;
      }, {});

      const treeData = Object.entries(grouped).map(
        ([category, items], index) => {
          const subCategories = Array.isArray(items)
            ? items
            : Object.entries(items || {}); 
          return {
            key: `${index}`,
            data: { Category: category },
            children: subCategories.map(([subCategory, subitems], subIndex) => {
              const subItemsArray = Array.isArray(subitems) ? subitems : [];
              return {
                key: `${index}-${subIndex}`,
                data: {
                  SubCategory: subCategory,
                },
                children: subItemsArray.map((itemData, dataIndex) => ({
                  key: `${index}-${subIndex}-${dataIndex}`,
                  data: {
                    Type: itemData.Type || "",
                    Key: itemData.Name || "",
                    Value: itemData.Desc,
                    IsPrivate: itemData.IsPrivate || false,
                    Id: itemData.Id || 0,
                  },
                })),
              };
            }),
          };
        }
      );
      setTreeTableData(treeData);
      setIsloading(false);
    } catch (error) {
      console.error("Error loading system alerts", error);
      setIsloading(false);
    }
  }

  const onHandleEdit = (item) => {
    setEditSystemAlertId(item.Id);
    setEditDescriptions((prev) => ({
      ...prev,
      [item.Id]: item.Value, 
    }));
  };
  const onHandleCancelEdit = (item) => {};
  return (
    <div className="setting-detail-list">
      <div className="detail award-detail">
        <div className="input-group search-area2 d-xl-inline-flex mb-3 me-4"></div>
        <div className="title-text">
          <h3>System Alerts ({orgSystemAlertList?.length})</h3>
          <div className="d-flex">
            <InputText
              name="requestTitle"
              className="form-control search-grpname me-2"
              onChange={handleInputChange}
              placeholder="Search"
            />
          </div>
        </div>

        <div className="col-md-12 column">
          <TreeTable value={treeTableData} tableStyle={{ minWidth: "60rem" }} className="table table-bordered table-hover">
            <Column field="Category" header="Category" expander />
            <Column field="SubCategory" header="Sub Category" />
            <Column field="Type" header="Type" />
            <Column field="Key" header="Key" />
            <Column
              header="Value"
              body={(node) =>
                editSystemAlertId === node.data.Id ? (
                  <InputText
                    name="Value"
                    className="form-control search-grpname me-2"
                    value={alertDescription[node.data.Id] ?? node.data.Value}
                    onChange={(e) =>
                      setEditDescriptions((prev) => ({
                        ...prev,
                        [node.data.Id]: e.target.value,
                      }))
                    }
                    placeholder="Value"
                  />
                ) : (
                  node.data.Value
                )
              }
            />

            <Column
              header="Action"
              body={(node) =>
                node.data?.IsPrivate && editSystemAlertId != node.data?.Id ? (
                  <div className="flex flex-wrap gap-2">
                    <button className="editactions me-2">
                      <img
                        src="/images/tickets/edit-ico.svg"
                        title="Edit"
                        className="editactions me-2"
                        onClick={() => onHandleEdit(node.data)}
                        />
                    </button>
                  </div>
                ) : (
                  node.data?.IsPrivate &&
                  editSystemAlertId == node.data?.Id && (
                    <div className="flex flex-wrap gap-2">
                      <button className="editactions me-2">
                        <img
                          src="/images/org-img/profile/close.png"
                          title="Cancel"
                          className="editactions me-2"
                          onClick={() => {
                            onHandleCancelEdit(node.data);
                            setEditSystemAlertId(null);
                          }}
                        />
                      </button>
                      <button className="editactions ">
                        <img
                          src="/images/org-img/profile/check.png"
                          title="Confirm"
                          className="editactions"
                          style={{ width: "17px" }}
                          onClick={() => {
                            onHandleEdit(node.data);
                            const updatedValue = alertDescription[node.data.Id];
                            setEditSystemAlertId(null);
                          }}
                        />
                      </button>
                    </div>
                  )
                )
              }
            />
          </TreeTable>
        </div>
      </div>
      {isLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default OrgSystemAlert;
